<template>
  <v-card>
    <v-card-text>
      <v-form @submit.prevent="initialisation">
        <v-text-field
          ref="pdv"
          v-model="pdv"
          :prepend-inner-icon="IconEnum.shop_field"
          :label="$t('field.index.pdv')"
          name="pdv"
          type="number"
          inputmode="decimal"
          class="needsclick"
          @input="inputPosField"
        />
        <v-text-field
          ref="licence"
          v-model="licence"
          :prepend-inner-icon="IconEnum.licence"
          :label="$t('field.index.licence')"
          name="licence"
          type="number"
          inputmode="decimal"
          class="needsclick"
          @input="inputLicenceField"
        />
        <v-text-field
          v-show="!IS_DESKTOP"
          ref="rank"
          v-model="rank"
          :prepend-inner-icon="IconEnum.rank"
          :label="$t('field.index.rank')"
          :error-messages="errorMessages"
          name="rank"
          type="number"
          inputmode="decimal"
          class="needsclick"
          @input="inputRankField"
          @focusout="inputRankField(rank)"
        />
        <input
          type="submit"
          style="display: none"
        >
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-btn
        id="btn-init"
        color="success"
        class="bloc"
        @click="initialisation"
      >
        {{ $t('button.dw_initialization') }}
      </v-btn>

      <div class="d-flex">
        <v-switch
          v-if="!IS_DESKTOP"
          v-model="replace"
          :label="$t('field.replace')"
          color="accent"
          class="ml-auto mr-3"
          hide-details
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { $closeKeyboard } from '@/modules/Utils'

export default {
  name: 'TerminalConnection',

  data () {
    return {
      IconEnum,
      IS_DESKTOP,
      errorMessages: null,
      //
      pdv: '',
      licence: '',
      rank: IS_DESKTOP ? '991' : '',
      replace: IS_DESKTOP
    }
  },
  methods: {
    inputPosField (value) {
      if (value.length > 8) {
        this.$nextTick(() => {
          this.pdv = this.pdv.substring(0, 8)
        })
      }
    },
    inputLicenceField (value) {
      if (value.length > 10) {
        this.$nextTick(() => {
          this.licence = this.licence.substring(0, 10)
        })
      }
    },
    inputRankField (value) {
      const val = parseInt(value)
      if (val < 1 || val > 990) {
        this.errorMessages = this.$i18n.t('field.bad_rank')
        this.$nextTick(() => {
          this.rank = this.rank.substring(0, value.length > 3 ? 3 : 2)
        })
      } else {
        this.errorMessages = null
      }
    },
    initialisation () {
      if (this.pdv === '') {
        this.$nextTick(() => {
          this.$refs.pdv.focus()
        })
      } else if (this.licence === '') {
        this.$nextTick(() => {
          this.$refs.licence.focus()
        })
      } else if (!IS_DESKTOP && this.rank === '') {
        this.$nextTick(() => {
          this.$refs.rank.focus()
        })
      } else {
        $closeKeyboard(this.$nextTick)

        this.$emit('valid', this.pdv, this.licence, this.rank, this.replace)
      }
    }
  }
}
</script>
